"use client";

import { useState } from "react";
import { sendPasswordResetEmail } from "@/server-actions/auth/forgotPassword";
import Cookies from "js-cookie";
import Link from "next/link";

export default function ForgotPasswordForm() {
  const [email, setEmail] = useState(Cookies.get("userEmail") || "");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    const result = await sendPasswordResetEmail(email);
    
    setLoading(false);

    if (result.error) {
      setError(result.message);
    } else {
      setMessage(result.message);
    }
  };

  return (
    <>
      {message && <p className="mt-4 mb-4 text-green-500 text-center">{message}</p>}
      {error && <p className="mt-4 mb-4 text-red-500 text-center">{error}</p>}
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div>
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700"
          >
            Email address
          </label>
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-xs appearance-none focus:outline-hidden focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
        </div>
        <div>
          <button
            type="submit"
            disabled={loading}
            className={`flex w-full justify-center rounded-md bg-blue-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm ${
              loading ? "bg-blue-400" : "hover:bg-blue-500"
            } focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600`}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </div>
      </form>
      <div className="mt-4 text-center">
        <Link
          href="/"
          className="text-sm font-medium text-blue-600 hover:text-blue-800"
        >
          Back to sign in
        </Link>
      </div>
    </>
  );
}